// extracted by mini-css-extract-plugin
module.exports = {"pagination":"UpdatesPagination-module--pagination--WvDFH","help":"UpdatesPagination-module--help--1n9QL","actions":"UpdatesPagination-module--actions--2aspW"};